import React, { useState, useEffect, useContext } from "react";
import "./Hospitalbooking.css";
import Mobile from "../../component/mobile/mobile";
import { FaCalendar } from "react-icons/fa";
import carebanner from "../../assets/banr.png";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addDays, format } from "date-fns";
import { UserContext } from "../../context/UserContext";
import { Hospitalbooking } from "../../env/action";
import { useParams } from "react-router-dom";
import moment from "moment";

export default function Hospitalbookingpage() {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedTime, setSelectedTime] = useState(null);
  const { userData, setUserData, token, hospitalid } = useContext(UserContext);
  const [selection, setSelection] = useState("self");
  const [fullname, setFullname] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const { id: hospitalId } = useParams();
  useEffect(() => {
  if (selection === "self" && userData) {
    const fullAddress = `${userData.address || ""}, ${userData.locality || ""}, ${
      userData.city || ""
    }, ${userData.dist || ""}, ${userData.state || ""}, ${userData.pincode || ""}`;

    setFullname(userData.name || "");
    setMobile(userData.phone_number || "");
    setEmail(userData.email || "");
    setAddress(fullAddress);
    setReason("");
  } else if (selection === "other") {
    setFullname("");
    setMobile("");
    setEmail("");
    setAddress("");
    setReason("");
  }
 }, [selection, userData]);

  const quickDates = [
    { label: "Today", offset: 0 },
    { label: "Tomorrow", offset: 1 },
    { label: format(addDays(new Date(), 2), "EEEE"), offset: 2 }, // Thursday
    { label: format(addDays(new Date(), 3), "EEEE"), offset: 3 }, // Friday
  ];
  const handleBookingdetails = (e) => {
      if (!token) {
      alert("Please login before Booking.");
      return;
     }
    const formattedDate = moment(selectedDate).format("YYYY-MM-DD");
    e.preventDefault();

    if (!selectedDate) {
      alert("Please select a date.");
      return;
    }

    if (!selectedTime) {
      alert("Please select a time.");
      return;
    }

    if (!fullname) {
      alert("Please enter Fullname.");
      return;
    }
    if (!mobile) {
      alert("Please enter Mobile Number.");
      return;
    }
    if (!email) {
      alert("Please enter Email.");
      return;
    }
    if (!address) {
      alert("Please enter Address.");
      return;
    }
    if (!reason) {
      alert("Please enter a valid reason.");
      return;
    }
    setLoading(true);
    const params = {
      user_id: userData.user_id,
      hospital_id: hospitalId,
      date: formattedDate,
      time: selectedTime,
      fullname: fullname,
      mobile: mobile,
      email: email,
      address: address,
      reason: reason,
      type: selection,
      source: "web",
    };

    Hospitalbooking(params, token, (res) => {
      setLoading(false);
      console.log("Booking response:", res);
      if (res) {
        if (res.status === 0) {
          alert("Error: " + res.message);
        } else {
          alert("Success: " + res.message);
          window.location.reload();
        }
      } else {
        alert("Error: Unexpected response from server.");
      }
    });
  };

  const allSlots = [
    "8:00 AM",
    "9:00 AM",
    "10:00 AM",
    "11:00 AM",
    "12:00 PM",
    "1:00 PM",
    "2:00 PM",
    "3:00 PM",
    "4:00 PM",
    "5:00 PM",
    "6:00 PM",
    "7:00 PM",
    "8:00 PM",
    "9:00 PM",
    "10:00 PM",
  ];

  const isToday = moment(selectedDate).isSame(moment(), "day");

  const isTimeDisabled = (timeStr) => {
    if (!isToday) return false;
    const now = moment();
    const slot = moment(timeStr, "h:mm A");
    return now.isAfter(slot);
  };

  const visibleSlots = allSlots.filter((timeStr) => !isTimeDisabled(timeStr));

  return (
    <div>
      <div className="care-banner">
        <img src={carebanner} alt="Care Banner" className="banner-img" />
      </div>

      <div className="nursingCare">
        <p className="text-center fw-bolder text-1">
          Booking Consultation with Hospital
        </p>
      </div>

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-12">
            <div className="addpays border rounded shadow-sm">
              <div className="row justify-content-center m-0">
                <div className="col-md-6 custom-border-right">
                  <div className="slot-header text-center mb-3">
                    Choose Slot
                  </div>

                  <div className="date-selector border rounded p-3">
                    <p className="fw-bold mb-3">Select a date</p>
                    <div className="d-flex gap-2 flex-wrap justify-content-center">
                      {quickDates.map(({ label, offset }, index) => {
                        const date = addDays(new Date(), offset);
                        const formatted = format(date, "d MMM");

                        return (
                          <button
                            key={index}
                            className={`date-btn ${
                              format(selectedDate, "yyyy-MM-dd") ===
                              format(date, "yyyy-MM-dd")
                                ? "selected"
                                : ""
                            }`}
                            onClick={() => {
                              setSelectedDate(date);
                              setShowCalendar(false);
                            }}
                          >
                            <div>{formatted}</div>
                            <small>{label}</small>
                          </button>
                        );
                      })}

                      <button
                        className="date-btn"
                        onClick={() => setShowCalendar(!showCalendar)}
                      >
                        <FaCalendar
                          style={{ fontSize: "17px", color: "#004acc" }}
                        />
                        {/* <i className="fa-regular fa-calendar"></i><br /> */}
                        <small>Pick a date</small>
                      </button>
                    </div>

                    {showCalendar && (
                      <div className="mt-3 text-center">
                        <DatePicker
                          selected={selectedDate}
                          onChange={(date) => {
                            setSelectedDate(date);
                            setShowCalendar(false);
                          }}
                          inline
                          minDate={new Date()}
                        />
                      </div>
                    )}

                    {/* Show selected date */}
                    <div className="mt-3 selected-date-text">
                      <strong>
                        {selectedDate.toLocaleDateString("en-US", {
                          weekday: "long",
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })}
                      </strong>
                    </div>
                  </div>

                  <div className="time-selector border rounded p-3 mt-4">
                    <p className="fw-bold mb-1">Select a time</p>
                    <p className="text-muted" style={{ fontSize: "14px" }}>
                      Session duration will be between 30–45 mins
                    </p>

                    <div className="time-grid mt-2">
                      {visibleSlots.map((time, index) => (
                        <button
                          key={index}
                          className={`time-btn ${
                            selectedTime === time ? "selected" : ""
                          }`}
                          onClick={() => setSelectedTime(time)}
                        >
                          {time}
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* <div className="text-center mt-4">
                    <button className="continue-btn">Continue</button>
                  </div> */}
                </div>

                <div className="col-md-6">
                  <div className="slot-header text-center mb-3">
                    Book Your Hospital Now
                  </div>

                  <div className="duration-selector p-2 mb-4">
                    <div className="d-flex">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="duration"
                          id="Self"
                          value="self"
                          checked={selection === "self"}
                          onChange={() => setSelection("self")}
                        />
                        <label className="form-check-label" htmlFor="Self">
                          Self
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="duration"
                          id="Others"
                          value="other"
                          checked={selection === "other"}
                          onChange={() => setSelection("other")}
                        />
                        <label className="form-check-label" htmlFor="Others">
                          Others
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="form-sections border rounded p-3">
                    <form onSubmit={handleBookingdetails}>
                      <div className="mb-3">
                        <label className="form-label">Name*</label>
                        <input
                          type="text"
                          className="form-control"
                          value={fullname}
                          onChange={(e) => setFullname(e.target.value)}
                          placeholder="Patient Name*"
                          required
                          readOnly={selection === "self"}
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Mobile Number*</label>
                        <input
                          type="tel"
                          className="form-control"
                          value={mobile}
                          onChange={(e) => {
                            const input = e.target.value;
                            if (/^\d{0,10}$/.test(input)) {
                              setMobile(input);
                            }
                          }}
                          placeholder="Mobile Number*"
                          required
                          readOnly={selection === "self"}
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Email*</label>
                        <input
                          type="email"
                          className="form-control"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          placeholder="Email*"
                          required
                          readOnly={selection === "self"}
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Address*</label>
                        <textarea
                          className="form-control"
                          value={address}
                          onChange={(e) => setAddress(e.target.value)}
                          placeholder="Full Address*"
                          required
                          readOnly={selection === "self"}
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Reason*</label>
                        <input
                          type="text"
                          className="form-control"
                          value={reason}
                          onChange={(e) => setReason(e.target.value)}
                          placeholder="Enter Reason here"
                          required
                        />
                      </div>

                      <div className="text-center mt-4">
                        <button type="submit" className="continue-btn">
                          Book Appointment
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Mobile />
    </div>
  );
}
